//Glyphicons classes definitons
export const 
    ADD_GLYPH= "glyphicon-plus",
    HOME_GLYPH="glyphicon-home",
    DELETE_GLYPH= "glyphicon-remove",
    EDIT_GLYPH= "glyphicon-pencil",
    OK_GLYPH = "glyphicon-ok",
    SEARCH_GLYPH = "glyphicon-search",
    COMPANY_GLYPH= "glyphicon-briefcase", 
    USER_GLYPH = "glyphicon-user",
    LIST_GLYPH = "glyphicon-list-alt",
    NEXT_GLYPH = "glyphicon-chevron-right",
    PREVIOUS_GLYPH = "glyphicon-chevron-left",
    SAVE_GLYPH = "glyphicon-floppy-disk";



// WEBPACK FOOTER //
// ./src/const/Glyphicons.js